import React from "react";
import {
  Card,
  Box,
  Heading,
  Button,
  CardHeader,
  CardBody,
  CardFooter,
} from "@chakra-ui/react";
import { Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";

import { Cell, LedgerRow, RowActions, StatusMark } from "../../components/ui";

function AllusersCard({ User,eventL,horoL,appointL }) {
  
  
  
  return (
    <LedgerRow stripe={User.remainAmmount==0 ? "paid" : "unpaid"}>
        <Cell full>
          <Text fontWeight={600}>{User.fname} {User.lname}</Text>
          <Text fontSize="sm" color="stone.500">{User.phone}{User.email ? `, ${User.email}` : ""}</Text>
        </Cell>
        <Cell label="Appts">{appointL}</Cell>
        <Cell label="Astro">{horoL}</Cell>
        <Cell label="Events">{eventL}</Cell>
        <Cell label="Total">{User.remainAmmount + User.paidAmmount}</Cell>
        <Cell label="Settled"><Text color="tulsi.700" fontWeight={600}>{User.paidAmmount}</Text></Cell>
        <Cell label="Unsettled"><Text fontWeight={600}>{User.remainAmmount}</Text></Cell>
        <Cell full><RowActions><Button as={Link} to={`/admin/usersDtails/${User._id}`} variant="outline" size="sm">View</Button></RowActions></Cell>

      
          </LedgerRow>
  );
}

export default AllusersCard;
